import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import Footer from './footer.js';
import ProjectGrid from './project-grid.js';
import Picture from './picture.js';
import Underliner from './underliner.js';
import {scrollIt} from './helper-lib.js';

class Project extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        showMore: false,
        isMobile: false
      }

      this.handleMore = this.handleMore.bind(this);
      this.scrollToElement = this.scrollToElement.bind(this);
    }

    componentDidMount() {
      this.descriptionText = document.querySelector('.description .text');
      this.detailsCnt = document.querySelector('.details-cnt');
      window.addEventListener('resize', this.handleResize);
      window.dispatchEvent(new Event('resize'));

      if(this.descriptionText && this.detailsCnt) {
        this.setMaxHeight(this.descriptionText, this.detailsCnt);
        window.addEventListener('resize', () => {this.setMaxHeight(this.descriptionText, this.detailsCnt)});
      }

      window.addEventListener('scroll', () => {
        window.scrollY > 100 ? document.body.classList.add('no-view-prj') : document.body.classList.remove('no-view-prj')
        window.scrollY > window.innerHeight - 50 ? document.body.classList.add('menu-black') : document.body.classList.remove('menu-black');
      });
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('resize', () => {this.setMaxHeight(this.descriptionText, this.detailsCnt)});
      window.addEventListener('scroll', () => {window.scrollY > 100 ? document.body.classList.add('no-view-prj') : document.body.classList.remove('no-view-prj')});
    }

    setMaxHeight = (elem, targetHeightElem) => {
      const computedStyle = window.getComputedStyle(elem);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const numberOfLines = Math.floor( targetHeightElem.getBoundingClientRect().height / lineHeight );

      if(targetHeightElem.getBoundingClientRect().height >= elem.querySelector('div').getBoundingClientRect().height) {
        elem.parentNode.classList.add('no-need');
      } else{
        elem.parentNode.classList.remove('no-need');
      }

      elem.style.maxHeight = `${numberOfLines * 1.4}em`;
    }

    handleResize = () => {
      if(window.innerWidth <= 900) {
        console.log('mobile cover');
        this.setState({
          isMobile: true
        });
      } else {
        console.log('desktop cover');
        this.setState({
          isMobile: false
        });
      }

      if(window.screen.availHeight - window.innerHeight > 50) {
        document.body.classList.add('bottom-bar-compensate');
      } else {
        document.body.classList.remove('bottom-bar-compensate');
      }
    }

    handleMore(e) {
      e.target.parentNode.parentNode.parentNode.classList.toggle('show-more');
      this.setState({
        showMore: !this.state.showMore
      });
    }

    scrollToElement(e) {
      // const cnt = document.querySelector('.App > div > div');
      const cnt = window;

      scrollIt(
        cnt,
        window.innerHeight,
        400,
        'easeOutQuad'
      );
    }

    render() {
      const project = DataStore.getProjectBySlug(this.props.match.params.slug);

      return (
        <div>
          <Layout>
            <section className="cover">
              {!this.state.isMobile ?
              <Picture data={project.acf.cover} />:<Picture data={project.acf.cover_mobile} />
              }
              <header className="project-header">
                <Underliner className="view-project-cnt">
                  <button className="view-project"
                        onClick={this.scrollToElement}
                  ><span className="text">View Project</span> <span className="down-arrow"></span></button>
                </Underliner>
              </header>
            </section>
            <section className="project-info" ref="project_info">
              <div className="cnt">
                <div className="thumb-cnt">
                <h1 className="title" dangerouslySetInnerHTML={{__html: project.title.rendered}}></h1>
                  <div className="inner">
                    <div className="thumb">
                      <object type="image/svg+xml" aria-label="Project Graphic" alt="Project Graphic" data={project.acf.thumb.url} className="thumb-svg"></object>
                    </div>
                  </div>
                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
                <div className="details">
                  <div className="details-cnt">
                    <div className="row">
                      {project.acf.year.length > 0 ?
                      <div className="col year">
                        <div className="title">Year</div>
                        <span>{project.acf.year}</span>
                      </div>:null
                      }
                      {project.acf.location.length > 0 ?
                      <div className="col location">
                        <div className="title">Location</div>
                        <span>{project.acf.location}</span>
                      </div>:null
                      }
                    </div>
                    <div className="row">
                      {project.acf.area.length > 0 ?
                      <div className="col area">
                        <div className="title">Area</div>
                        <span>{project.acf.area}m<sup>2</sup></span>
                      </div>:null
                      }
                      {project.acf.type.length > 0 ?
                      <div className="col type">
                        <div className="title">Type</div>
                        <span>{project.acf.type}</span>
                      </div>:null
                      }
                    </div>
                    { project.acf.hasOwnProperty('awards1') && project.acf.awards1.length > 0 ?
                    <div className="row awards">
                      <div className="title">Awards</div>
                      <ul>
                      {project.acf.awards1.map( (award, i) => {
                        return <li key={i}>{award.award}</li>
                      })}
                      </ul>
                    </div>:null
                    }
                    { project.acf.extra_fields !== null && project.acf.extra_fields !== undefined && project.acf.extra_fields ?
                      project.acf.extra_fields.map((row, i)=>{
                        return <div key={i} className="row">
                                <div className="title">{row.title}</div>
                                <span>{row.description}</span>
                              </div>
                      }) : null
                    }
                  </div>
                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
                <div className="description">
                  {project.content.rendered.length > 0 ?
                  <div className="desc-cnt">
                    <div className="text">
                      <div dangerouslySetInnerHTML={{__html: project.content.rendered}} />
                    </div>
                    <Underliner>
                      <button className="read-more" onClick={this.handleMore}>Read {this.state.showMore ? 'Less' : 'More'}</button>
                    </Underliner>
                  </div>:null
                  }
                  <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
              </div>
            </section>
            {project.acf.gallery !== null && project.acf.gallery.length > 0 ?
            <section className="gallery">
              <div className="cnt">
                {project.acf.gallery.map((image, i) => {
                  return <Picture key={i} data={image.image} width={image.width} />
                })}
              </div>
              <div className="cnt">
                <div className="bottom-crosses">
                  <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                  <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
                </div>
              </div>
            </section>:null
            }
            <div className="grid-title">
              <div className="cnt">
                <div className="title">MORE PROJECTS</div>
              </div>
            </div>
            <ProjectGrid currentProject={project.id} />
          </Layout>
          <Footer footerClass="project" />
        </div>
      );
    }
}

export default Project;



// WEBPACK FOOTER //
// ./src/scripts/components/project.js